export type Language = "de" | "en" | "it" | "es" | "nl";

export const translations = {
  /* ═══════════════════════════════ DEUTSCH (MASTER) ═══════════════════════════════ */
  de: {
    nav: {
      home: "Startseite",
      about: "Agentur",
      products: "Sortiment",
      contact: "Kontakt",
      selection: "Lichtauswahl",
      lighting: "Beleuchtung",
      howItWorks: "So funktioniert's",
      tagline: "Erlesene Leuchten und Möbel für architektonische und Innenräume.",
      browseLighting: "Beleuchtung entdecken",
      manufacturers: "Hersteller",
      lamps: "Leuchten",
      furniture: "Möbel",
      allManufacturers: "Alle Hersteller entdecken",
      order: "Bestellen",
    },
    hero: {
      kicker: "Frank Pistorius — Handelsagentur für Licht",
      title: "Räume mit Licht gestalten.",
      subtitle: "Architektonische Leuchten und ausgewählte Möbel.",
      cta: "Projekt besprechen",
      ctaSecondary: "Lichtberatung anfragen",
      catalogue: "Katalog",
    },
    chooseLamps: {
      title: "Wählen Sie Ihre perfekte Leuchte",
      text: "Beleuchten Sie Ihren Raum mit Frank Pistorius' ausgewählten Designs und verwandeln Sie jeden Raum in ein stilvolles Refugium des Lichts.",
      cta: "Sortiment durchstöbern",
    },
    categories: {
      pendants: "Pendelleuchten & Kronleuchter",
      pendantsDesc: "Statement-Beleuchtung für Essbereiche, Wohnräume, Lobbys und Hospitality-Projekte — ausgewählt für Designqualität und langfristige Relevanz.",
      wallArchitectural: "Architektur- & Wandleuchten",
      wallArchitecturalDesc: "Klare, funktionale Lösungen für Flure, Schlafzimmer und Feature-Wände — mit Planungsunterstützung für reale Räume.",
      tableFloor: "Tisch- & Stehleuchten",
      tableFloorDesc: "Flexible, designorientierte Stücke, die Atmosphäre und Komfort bringen — ideal für private Interieurs und Boutique-Projekte.",
      byRequest: "Auf Anfrage",
      viewCollection: "Kollektion ansehen",
    },
    midCta: {
      text: "Maßgeschneiderte Beratung für die richtige Beleuchtung Ihres Raums — ob Renovierung, Neubau oder individuelles Interieur-Projekt.",
    },
    experience: {
      title: "Über 35 Jahre Lichtexpertise und Markterfahrung.",
      cta: "Mehr über das Unternehmen",
      stat1Title: "35+ Jahre Erfahrung",
      stat1Desc: "Jahrzehntelange Branchenkenntnis, aufgebaut auf langfristigen Beziehungen zu Herstellern und Händlern.",
      stat2Title: "Kuratierte Hersteller",
      stat2Desc: "Ein fokussiertes Portfolio von Marken, ausgewählt nach Designstärke, Qualität und Zuverlässigkeit.",
      stat3Title: "Projektunterstützung",
      stat3Desc: "Unterstützung bei Planung, Auswahl und Koordination — für architektonische und Innenräume.",
      stat4Title: "Direkter Kontakt",
      stat4Desc: "Ein klarer Ansprechpartner, schnelle Antworten und persönliche Betreuung von der ersten Anfrage bis zur Bestellung.",
    },
    footerCta: {
      title: "Bleiben Sie verbunden.",
      text: "Erhalten Sie gelegentliche Updates und kontaktieren Sie uns jederzeit für Projektunterstützung oder individuelle Leuchten.",
    },
    positioning: {
      headline: "Erfahrung, die die Auswahl erleichtert.",
      text: "Mehr als drei Jahrzehnte Marktkenntnis und ein sorgfältig kuratiertes Portfolio — damit die richtige Lösung schneller gefunden wird. Mit einem klaren Ansprechpartner.",
    },
    selection: {
      title: "Lichtauswahl",
      subtitle: "Keine endlose Suche. Sondern ein kuratierter Weg zur richtigen Lösung.",
      step1Title: "Raum verstehen",
      step1Desc: "Wir beginnen mit dem Raum, der Architektur, der Stimmung. Nicht mit einem Katalog.",
      step2Title: "Marken & Typologien kuratieren",
      step2Desc: "Aus unserem Portfolio wählen wir die Hersteller und Leuchtentypen, die zur Aufgabe passen.",
      step3Title: "Spezifikationen koordinieren",
      step3Desc: "Technische Details, Verfügbarkeit, Sonderanfertigungen — alles aus einer Hand.",
      step4Title: "Begleiten bis zur Entscheidung",
      step4Desc: "Wir unterstützen Architekten, Planer und Bauherren bis zur finalen Auswahl.",
    },
    manufacturers: {
      title: "Ausgewählte Hersteller",
      subtitle: "Internationale Designmarken, persönlich kuratiert.",
      kdln: { name: "KDLN", short: "Poetisches Licht aus Mailand. Unkonventionelle Formen seit 1996." },
      quasar: { name: "Quasar Holland", short: "Avantgarde-Kronleuchter und Lichtobjekte aus den Niederlanden." },
      vistosi: { name: "Vistosi", short: "Mundgeblasenes Muranoglas. Tradition seit 1585." },
      nemo: { name: "Nemo Lighting", short: "Mailänder Lichtkultur. Le Corbusier bis heute." },
      aemotional: { name: "a·emotional light", short: "Skulpturale Lichtobjekte. Handwerk trifft Emotion." },
      vibieffe: { name: "Vibieffe", short: "Italienische Polstermöbel. Zeitlos elegant seit 1968." },
    },
    products: {
      title: "Sortiment",
      subtitle: "Leuchten und Möbel ausgewählter Manufakturen.",
      categories: "Leuchten nach Typologie",
      lamps: "Leuchten",
      furniture: "Möbel",
      pendant: "Pendelleuchten",
      pendantDesc: "Skulpturale Präsenz über Tisch und Raum.",
      wall: "Wandleuchten",
      wallDesc: "Akzente setzen. Licht an der Architektur.",
      floor: "Stehleuchten",
      floorDesc: "Freistehende Lichtgesten für jeden Raum.",
      table: "Tischleuchten",
      tableDesc: "Intimes Licht. Nah und persönlich.",
      architectural: "Architekturleuchten",
      architecturalDesc: "Eingebaut. Integriert. Unsichtbar und wirkungsvoll.",
      outdoor: "Außenleuchten",
      outdoorDesc: "Licht für Fassade, Garten und Landschaft.",
      manufacturersTitle: "Unsere Hersteller",
      manufacturersSubtitle: "Jede Marke in unserem Portfolio wurde persönlich ausgewählt — für Qualität, Designsprache und Haltung.",
    },
    about: {
      title: "Die Agentur",
      subtitle: "Handelsagentur für Licht",
      story: "Über 30 Jahre Erfahrung in Lichtvertrieb und Beratung. Unabhängige Agentur mit Sitz in Bochum, die ausgewählte internationale Designmarken vertritt.",
      story2: "Frank Pistorius agiert als Berater, Kurator und Schnittstelle zwischen Hersteller und Projekt. Ob Architekt, Innenarchitekt, Hotel, Bauträger oder Privatkunde — der Fokus liegt immer auf der richtigen Lösung.",
      positioning: "Erfahrung, die die Auswahl erleichtert. Mehr als drei Jahrzehnte Marktkenntnis und ein sorgfältig kuratiertes Portfolio, damit die richtige Lösung schneller gefunden wird — mit einem klaren Ansprechpartner.",
      values: "Haltung",
      value1Title: "Kuratiert",
      value1Desc: "Kein Massensortiment. Jeder Hersteller wurde bewusst gewählt.",
      value2Title: "Unabhängig",
      value2Desc: "Keine Konzernbindung. Beratung im Interesse des Projekts.",
      value3Title: "Persönlich",
      value3Desc: "Ein Ansprechpartner. Direkt, verbindlich, erreichbar.",
      founderName: "Frank Pistorius",
      founderRole: "Gründer & Inhaber",
      founderAlt: "Frank Pistorius – Gründer der Handelsagentur für Licht",
      heroSubline: "Handelsagentur für Licht",
      heroInfo1: "Seit über 30 Jahren Handelsagentur für Licht und Einrichtung.",
      heroInfo2: "Kuratiertes Portfolio, klare Beratung, persönliche Betreuung.",
      heroInfo3: "Für Architektur, Interior und anspruchsvolle Projekte.",
    },
    contact: {
      title: "Projekt starten",
      subtitle: "Beschreiben Sie Ihr Projekt — wir finden die passende Lösung.",
      name: "Name",
      email: "E-Mail",
      phone: "Telefon",
      message: "Projektbeschreibung",
      projectType: "Projektart",
      send: "Projektanfrage senden",
      info: "Direkter Kontakt",
      address: "Adresse",
      hours: "Erreichbarkeit",
      hoursValue: "Mo–Fr: 10:00 – 18:00 Uhr",
      cta1: "Lichtberatung anfragen",
      cta2: "Leuchte auswählen",
      contactUs: "Kontakt aufnehmen",
      nameRequired: "Name ist erforderlich.",
      emailRequired: "E-Mail ist erforderlich.",
      emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      messageRequired: "Bitte beschreiben Sie Ihr Projekt.",
      privacyRequired: "Bitte akzeptieren Sie die Datenschutzerklärung.",
      privacyLabel: "Ich akzeptiere die",
      privacyLink: "Datenschutzerklärung",
      successTitle: "Anfrage gesendet",
      successText: "Vielen Dank für Ihre Anfrage. Wir melden uns zeitnah bei Ihnen.",
      newInquiry: "Neue Anfrage starten",
    },
    footer: {
      rights: "Alle Rechte vorbehalten.",
      tagline: "Handelsagentur für Licht",
      forCustomers: "Für Kunden",
      support: "Hilfe",
      followUs: "Folgen Sie uns",
      stayConnected: "Bleiben Sie verbunden.",
      stayConnectedText: "Erhalten Sie gelegentliche Updates und kontaktieren Sie uns jederzeit.",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      cookiePolicy: "Cookie-Richtlinie",
      terms: "Nutzungsbedingungen",
    },
    assistant: {
      title: "Projektassistent",
      whatPlanning: "Was planen Sie?",
      singleLuminaire: "Einzelne Leuchte",
      projectMultiple: "Projekt / mehrere Leuchten",
      fullInterior: "Komplette Inneneinrichtung",
      justBrowsing: "Nur informieren",
      whereProject: "Wo befindet sich das Projekt?",
      locationPlaceholder: "PLZ oder Stadt",
      whenRealized: "Wann soll es umgesetzt werden?",
      nowUrgent: "Sofort / dringend",
      months1to3: "In 1–3 Monaten",
      months3to6: "In 3–6 Monaten",
      notDecided: "Noch offen",
      yourName: "Wie heißen Sie?",
      namePlaceholder: "Vor- und Nachname",
      yourEmail: "Wie können wir Sie erreichen?",
      emailPlaceholder: "E-Mail-Adresse",
      phonePlaceholder: "Telefonnummer (optional)",
      next: "Weiter",
      back: "Zurück",
      skip: "Überspringen",
      submit: "Anfrage senden",
      thankYou: "Vielen Dank!",
      thankYouText: "Wir melden uns zeitnah bei Ihnen.",
    },
    floatingCta: {
      projectInquiry: "Projekt anfragen",
      whatsapp: "WhatsApp",
      call: "Anrufen",
      email: "E-Mail",
      form: "Formular",
      assistant: "Assistent",
    },
    theme: {
      light: "Helles Design",
      dark: "Dunkles Design",
    },
    lampCategories: {
      pendelleuchten: "Pendelleuchten",
      deckenleuchten: "Deckenleuchten",
      wandleuchten: "Wandleuchten",
      stehleuchten: "Stehleuchten",
      tischleuchten: "Tischleuchten",
      outdoor: "Außenleuchten",
      architektonisch: "Architekturleuchten",
    },
    furnitureCategories: {
      sofas: "Sofas",
      sessel: "Sessel",
      betten: "Betten",
      "tische-stuehle": "Tische & Stühle",
      accessoires: "Accessoires",
    },
  },

  /* ═══════════════════════════════ ENGLISH ═══════════════════════════════ */
  en: {
    nav: {
      home: "Home",
      about: "Agency",
      products: "Portfolio",
      contact: "Contact",
      selection: "Light Selection",
      lighting: "Lighting",
      howItWorks: "How it works",
      tagline: "Refined lighting and select furniture for architectural and interior spaces.",
      browseLighting: "Browse Lighting",
      manufacturers: "Manufacturers",
      lamps: "Lighting",
      furniture: "Furniture",
      allManufacturers: "Explore all manufacturers",
      order: "Order Now",
    },
    hero: {
      kicker: "Frank Pistorius — Lighting Sales Agency",
      title: "Shaping Spaces with Light.",
      subtitle: "Architectural luminaires and select furniture.",
      cta: "Discuss a project",
      ctaSecondary: "Request a lighting proposal",
      catalogue: "Catalogue",
    },
    chooseLamps: {
      title: "Find the Right Light for Your Space",
      text: "Architectural luminaires and select furniture, curated for interior projects that demand quality, precision, and lasting design.",
      cta: "Explore the Portfolio",
    },
    categories: {
      pendants: "Pendants and Chandeliers",
      pendantsDesc: "Statement lighting for dining areas, living spaces, lobbies, and hospitality projects, selected for design quality and long term relevance.",
      wallArchitectural: "Architectural and Wall Lighting",
      wallArchitecturalDesc: "Clean, functional solutions for corridors, bedrooms, and feature walls, with planning support for real spaces and real budgets.",
      tableFloor: "Table and Floor Lamps",
      tableFloorDesc: "Flexible, design focused pieces that bring atmosphere and comfort, ideal for private interiors and boutique projects.",
      byRequest: "By request",
      viewCollection: "View Collection",
    },
    midCta: {
      text: "Tailored guidance to help you choose the right lighting for your space, from renovation and new build to bespoke interior projects.",
    },
    experience: {
      title: "Over 35 years of lighting expertise and market experience.",
      cta: "Learn about the company",
      stat1Title: "35+ Years Experience",
      stat1Desc: "Decades of industry knowledge, built on long term relationships with manufacturers and retailers.",
      stat2Title: "Curated Manufacturers",
      stat2Desc: "A focused portfolio of brands selected for design strength, quality, and reliability.",
      stat3Title: "Project Support",
      stat3Desc: "Support with planning, selection, and coordination, for architectural and interior spaces.",
      stat4Title: "Direct Contact",
      stat4Desc: "One clear point of contact, fast responses, and hands on support from first request to final order.",
    },
    footerCta: {
      title: "Stay connected.",
      text: "Get the occasional update and reach out anytime for project support or individual lighting pieces.",
    },
    positioning: {
      headline: "Experience that makes choosing easier.",
      text: "More than three decades of market knowledge and a carefully curated portfolio — so the right solution is found faster. With one clear point of contact.",
    },
    selection: {
      title: "Light Selection",
      subtitle: "No endless browsing. A curated path to the right solution.",
      step1Title: "Understand the space",
      step1Desc: "We start with the room, the architecture, the mood. Not with a catalogue.",
      step2Title: "Curate brands & typologies",
      step2Desc: "From our portfolio, we select the manufacturers and luminaire types that fit the task.",
      step3Title: "Coordinate specifications",
      step3Desc: "Technical details, availability, custom solutions — all from one source.",
      step4Title: "Support until decision",
      step4Desc: "We accompany architects, planners, and clients through to the final selection.",
    },
    manufacturers: {
      title: "Selected Manufacturers",
      subtitle: "International design brands, personally curated.",
      kdln: { name: "KDLN", short: "Poetic light from Milan. Unconventional forms since 1996." },
      quasar: { name: "Quasar Holland", short: "Avant-garde chandeliers and lighting objects from the Netherlands." },
      vistosi: { name: "Vistosi", short: "Mouth-blown Murano glass. Tradition since 1585." },
      nemo: { name: "Nemo Lighting", short: "Milanese lighting culture. Le Corbusier to today." },
      aemotional: { name: "a·emotional light", short: "Sculptural lighting objects. Craft meets emotion." },
      vibieffe: { name: "Vibieffe", short: "Italian upholstered furniture. Timelessly elegant since 1968." },
    },
    products: {
      title: "Portfolio",
      subtitle: "Luminaires and furniture from selected manufacturers.",
      categories: "Luminaires by Typology",
      lamps: "Luminaires",
      furniture: "Furniture",
      pendant: "Pendant Lights",
      pendantDesc: "Sculptural presence above table and space.",
      wall: "Wall Lights",
      wallDesc: "Setting accents. Light on architecture.",
      floor: "Floor Lamps",
      floorDesc: "Freestanding light gestures for every room.",
      table: "Table Lamps",
      tableDesc: "Intimate light. Close and personal.",
      architectural: "Architectural Lights",
      architecturalDesc: "Built-in. Integrated. Invisible yet impactful.",
      outdoor: "Outdoor Lights",
      outdoorDesc: "Light for facades, gardens, and landscapes.",
      manufacturersTitle: "Our Manufacturers",
      manufacturersSubtitle: "Every brand in our portfolio was personally selected — for quality, design language, and conviction.",
    },
    about: {
      title: "The Agency",
      subtitle: "Lighting Sales Agency",
      story: "Over 30 years of experience in lighting distribution and consulting. An independent agency based in Bochum, representing selected international design brands.",
      story2: "Frank Pistorius acts as advisor, curator, and interface between manufacturer and project. Whether architect, interior designer, hotel, developer, or private client — the focus is always on the right solution.",
      positioning: "Experience that makes choosing easier. More than three decades of market knowledge and a carefully curated portfolio, so the right solution is found faster — with one clear point of contact.",
      values: "Principles",
      value1Title: "Curated",
      value1Desc: "No mass assortment. Every manufacturer was deliberately chosen.",
      value2Title: "Independent",
      value2Desc: "No corporate ties. Advice in the interest of the project.",
      value3Title: "Personal",
      value3Desc: "One point of contact. Direct, reliable, reachable.",
      founderName: "Frank Pistorius",
      founderRole: "Founder & Owner",
      founderAlt: "Frank Pistorius – Founder of the Lighting Sales Agency",
      heroSubline: "Lighting Sales Agency",
      heroInfo1: "Over 30 years as a sales agency for lighting and furniture.",
      heroInfo2: "Curated portfolio, clear guidance, personal support.",
      heroInfo3: "For architecture, interiors, and demanding projects.",
    },
    contact: {
      title: "Start a project",
      subtitle: "Describe your project — we'll find the right solution.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      message: "Project description",
      projectType: "Project type",
      send: "Send project inquiry",
      info: "Direct Contact",
      address: "Address",
      hours: "Availability",
      hoursValue: "Mon–Fri: 10:00 AM – 6:00 PM",
      cta1: "Request lighting consultation",
      cta2: "Select a luminaire",
      contactUs: "Contact Us",
      nameRequired: "Name is required.",
      emailRequired: "Email is required.",
      emailInvalid: "Please enter a valid email address.",
      messageRequired: "Please describe your project.",
      privacyRequired: "Please accept the privacy policy.",
      privacyLabel: "I accept the",
      privacyLink: "Privacy Policy",
      successTitle: "Inquiry sent",
      successText: "Thank you for your inquiry. We will get back to you shortly.",
      newInquiry: "New inquiry",
    },
    footer: {
      rights: "All rights reserved.",
      tagline: "Lighting Sales Agency",
      forCustomers: "For Customers",
      support: "Support",
      followUs: "Follow us",
      stayConnected: "Stay connected.",
      stayConnectedText: "Get the occasional update and reach out anytime.",
      impressum: "Imprint",
      datenschutz: "Privacy Policy",
      cookiePolicy: "Cookie Policy",
      terms: "Terms of Service",
    },
    assistant: {
      title: "Project Assistant",
      whatPlanning: "What are you planning?",
      singleLuminaire: "Single luminaire",
      projectMultiple: "Project / multiple luminaires",
      fullInterior: "Full interior",
      justBrowsing: "Just browsing",
      whereProject: "Where is the project located?",
      locationPlaceholder: "Postcode or city",
      whenRealized: "When should it be realised?",
      nowUrgent: "Now / urgent",
      months1to3: "In 1–3 months",
      months3to6: "In 3–6 months",
      notDecided: "Not yet decided",
      yourName: "What is your name?",
      namePlaceholder: "First and last name",
      yourEmail: "How can we reach you?",
      emailPlaceholder: "Email address",
      phonePlaceholder: "Phone number (optional)",
      next: "Next",
      back: "Back",
      skip: "Skip",
      submit: "Send inquiry",
      thankYou: "Thank you!",
      thankYouText: "We will get back to you shortly.",
    },
    floatingCta: {
      projectInquiry: "Project inquiry",
      whatsapp: "WhatsApp",
      call: "Call",
      email: "Email",
      form: "Form",
      assistant: "Assistant",
    },
    theme: {
      light: "Light mode",
      dark: "Dark mode",
    },
    lampCategories: {
      pendelleuchten: "Pendant Lights",
      deckenleuchten: "Ceiling Lights",
      wandleuchten: "Wall Lights",
      stehleuchten: "Floor Lamps",
      tischleuchten: "Table Lamps",
      outdoor: "Outdoor Lights",
      architektonisch: "Architectural Lights",
    },
    furnitureCategories: {
      sofas: "Sofas",
      sessel: "Armchairs",
      betten: "Beds",
      "tische-stuehle": "Tables & Chairs",
      accessoires: "Accessories",
    },
  },

  /* ═══════════════════════════════ ITALIANO ═══════════════════════════════ */
  it: {
    nav: {
      home: "Home",
      about: "Agenzia",
      products: "Catalogo",
      contact: "Contatto",
      selection: "Selezione luce",
      lighting: "Illuminazione",
      howItWorks: "Come funziona",
      tagline: "Illuminazione raffinata e arredi selezionati per spazi architettonici e d'interni.",
      browseLighting: "Scopri l'illuminazione",
      manufacturers: "Produttori",
      lamps: "Illuminazione",
      furniture: "Arredamento",
      allManufacturers: "Scopri tutti i produttori",
      order: "Ordina ora",
    },
    hero: {
      kicker: "Frank Pistorius — Agenzia commerciale per l'illuminazione",
      title: "Dare forma agli spazi con la luce.",
      subtitle: "Apparecchi architettonici e arredi selezionati.",
      cta: "Parliamo del progetto",
      ctaSecondary: "Richiedi una consulenza",
      catalogue: "Catalogo",
    },
    chooseLamps: {
      title: "Trova la luce perfetta per il tuo spazio",
      text: "Apparecchi architettonici e arredi selezionati, curati per progetti d'interni che richiedono qualità, precisione e design durevole.",
      cta: "Sfoglia il catalogo",
    },
    categories: {
      pendants: "Sospensioni e lampadari",
      pendantsDesc: "Illuminazione d'impatto per zone pranzo, soggiorni, lobby e progetti hospitality — selezionata per qualità progettuale e rilevanza duratura.",
      wallArchitectural: "Illuminazione architettonica e da parete",
      wallArchitecturalDesc: "Soluzioni pulite e funzionali per corridoi, camere e pareti d'accento — con supporto alla progettazione per spazi reali.",
      tableFloor: "Lampade da tavolo e da terra",
      tableFloorDesc: "Pezzi flessibili e orientati al design che portano atmosfera e comfort — ideali per interni privati e progetti boutique.",
      byRequest: "Su richiesta",
      viewCollection: "Vedi collezione",
    },
    midCta: {
      text: "Consulenza su misura per scegliere l'illuminazione giusta per il tuo spazio — dalla ristrutturazione alla nuova costruzione fino a progetti d'interni personalizzati.",
    },
    experience: {
      title: "Oltre 35 anni di competenza nell'illuminazione e esperienza di mercato.",
      cta: "Scopri l'agenzia",
      stat1Title: "35+ anni di esperienza",
      stat1Desc: "Decenni di conoscenza del settore, costruita su relazioni durature con produttori e rivenditori.",
      stat2Title: "Produttori selezionati",
      stat2Desc: "Un portfolio mirato di marchi scelti per forza progettuale, qualità e affidabilità.",
      stat3Title: "Supporto progettuale",
      stat3Desc: "Assistenza nella pianificazione, selezione e coordinamento — per spazi architettonici e d'interni.",
      stat4Title: "Contatto diretto",
      stat4Desc: "Un unico referente, risposte rapide e assistenza personale dalla prima richiesta all'ordine finale.",
    },
    footerCta: {
      title: "Resta in contatto.",
      text: "Ricevi aggiornamenti occasionali e contattaci in qualsiasi momento per supporto progettuale o pezzi di illuminazione individuali.",
    },
    positioning: {
      headline: "L'esperienza che semplifica la scelta.",
      text: "Più di tre decenni di conoscenza del mercato e un portfolio accuratamente curato — così la soluzione giusta si trova più velocemente. Con un unico referente.",
    },
    selection: {
      title: "Selezione luce",
      subtitle: "Nessuna ricerca infinita. Un percorso curato verso la soluzione giusta.",
      step1Title: "Comprendere lo spazio",
      step1Desc: "Partiamo dallo spazio, dall'architettura, dall'atmosfera. Non da un catalogo.",
      step2Title: "Curare marchi e tipologie",
      step2Desc: "Dal nostro portfolio selezioniamo i produttori e i tipi di apparecchi adatti al compito.",
      step3Title: "Coordinare le specifiche",
      step3Desc: "Dettagli tecnici, disponibilità, soluzioni personalizzate — tutto da un'unica fonte.",
      step4Title: "Accompagnare fino alla decisione",
      step4Desc: "Accompagniamo architetti, progettisti e committenti fino alla selezione finale.",
    },
    manufacturers: {
      title: "Produttori selezionati",
      subtitle: "Marchi di design internazionali, curati personalmente.",
      kdln: { name: "KDLN", short: "Luce poetica da Milano. Forme non convenzionali dal 1996." },
      quasar: { name: "Quasar Holland", short: "Lampadari d'avanguardia e oggetti luminosi dai Paesi Bassi." },
      vistosi: { name: "Vistosi", short: "Vetro di Murano soffiato a bocca. Tradizione dal 1585." },
      nemo: { name: "Nemo Lighting", short: "Cultura dell'illuminazione milanese. Da Le Corbusier a oggi." },
      aemotional: { name: "a·emotional light", short: "Oggetti luminosi scultorei. L'artigianato incontra l'emozione." },
      vibieffe: { name: "Vibieffe", short: "Mobili imbottiti italiani. Eleganza senza tempo dal 1968." },
    },
    products: {
      title: "Catalogo",
      subtitle: "Apparecchi e arredi di manifatture selezionate.",
      categories: "Apparecchi per tipologia",
      lamps: "Apparecchi",
      furniture: "Arredamento",
      pendant: "Sospensioni",
      pendantDesc: "Presenza scultorea sopra tavolo e spazio.",
      wall: "Applique",
      wallDesc: "Dare accenti. Luce sull'architettura.",
      floor: "Lampade da terra",
      floorDesc: "Gesti luminosi indipendenti per ogni stanza.",
      table: "Lampade da tavolo",
      tableDesc: "Luce intima. Vicina e personale.",
      architectural: "Illuminazione architettonica",
      architecturalDesc: "Integrata. Incorporata. Invisibile ma d'impatto.",
      outdoor: "Illuminazione esterna",
      outdoorDesc: "Luce per facciate, giardini e paesaggi.",
      manufacturersTitle: "I nostri produttori",
      manufacturersSubtitle: "Ogni marchio nel nostro portfolio è stato selezionato personalmente — per qualità, linguaggio progettuale e convinzione.",
    },
    about: {
      title: "L'agenzia",
      subtitle: "Agenzia commerciale per l'illuminazione",
      story: "Oltre 30 anni di esperienza nella distribuzione e consulenza illuminotecnica. Un'agenzia indipendente con sede a Bochum, che rappresenta marchi di design internazionali selezionati.",
      story2: "Frank Pistorius agisce come consulente, curatore e interfaccia tra produttore e progetto. Che si tratti di un architetto, interior designer, hotel, costruttore o cliente privato — il focus è sempre sulla soluzione giusta.",
      positioning: "L'esperienza che semplifica la scelta. Più di tre decenni di conoscenza del mercato e un portfolio accuratamente curato, così la soluzione giusta si trova più velocemente — con un unico referente.",
      values: "Valori",
      value1Title: "Curato",
      value1Desc: "Nessun assortimento di massa. Ogni produttore è stato scelto consapevolmente.",
      value2Title: "Indipendente",
      value2Desc: "Nessun legame aziendale. Consulenza nell'interesse del progetto.",
      value3Title: "Personale",
      value3Desc: "Un unico referente. Diretto, affidabile, raggiungibile.",
      founderName: "Frank Pistorius",
      founderRole: "Fondatore e titolare",
      founderAlt: "Frank Pistorius – Fondatore dell'agenzia commerciale per l'illuminazione",
      heroSubline: "Agenzia commerciale per l'illuminazione",
      heroInfo1: "Da oltre 30 anni agenzia commerciale per illuminazione e arredamento.",
      heroInfo2: "Portfolio curato, consulenza chiara, assistenza personale.",
      heroInfo3: "Per architettura, interni e progetti esigenti.",
    },
    contact: {
      title: "Inizia un progetto",
      subtitle: "Descrivi il tuo progetto — troveremo la soluzione giusta.",
      name: "Nome",
      email: "E-mail",
      phone: "Telefono",
      message: "Descrizione del progetto",
      projectType: "Tipo di progetto",
      send: "Invia richiesta",
      info: "Contatto diretto",
      address: "Indirizzo",
      hours: "Disponibilità",
      hoursValue: "Lun–Ven: 10:00 – 18:00",
      cta1: "Richiedi consulenza illuminotecnica",
      cta2: "Scegli un apparecchio",
      contactUs: "Contattaci",
      nameRequired: "Il nome è obbligatorio.",
      emailRequired: "L'e-mail è obbligatoria.",
      emailInvalid: "Inserisci un indirizzo e-mail valido.",
      messageRequired: "Descrivi il tuo progetto.",
      privacyRequired: "Accetta l'informativa sulla privacy.",
      privacyLabel: "Accetto l'",
      privacyLink: "informativa sulla privacy",
      successTitle: "Richiesta inviata",
      successText: "Grazie per la tua richiesta. Ti risponderemo al più presto.",
      newInquiry: "Nuova richiesta",
    },
    footer: {
      rights: "Tutti i diritti riservati.",
      tagline: "Agenzia commerciale per l'illuminazione",
      forCustomers: "Per i clienti",
      support: "Assistenza",
      followUs: "Seguici",
      stayConnected: "Resta in contatto.",
      stayConnectedText: "Ricevi aggiornamenti occasionali e contattaci in qualsiasi momento.",
      impressum: "Impronta",
      datenschutz: "Privacy",
      cookiePolicy: "Cookie Policy",
      terms: "Condizioni di Servizio",
    },
    assistant: {
      title: "Assistente progetto",
      whatPlanning: "Cosa stai progettando?",
      singleLuminaire: "Singolo apparecchio",
      projectMultiple: "Progetto / più apparecchi",
      fullInterior: "Arredamento completo",
      justBrowsing: "Solo informazioni",
      whereProject: "Dove si trova il progetto?",
      locationPlaceholder: "CAP o città",
      whenRealized: "Quando deve essere realizzato?",
      nowUrgent: "Subito / urgente",
      months1to3: "Entro 1–3 mesi",
      months3to6: "Entro 3–6 mesi",
      notDecided: "Non ancora deciso",
      yourName: "Come ti chiami?",
      namePlaceholder: "Nome e cognome",
      yourEmail: "Come possiamo contattarti?",
      emailPlaceholder: "Indirizzo e-mail",
      phonePlaceholder: "Numero di telefono (facoltativo)",
      next: "Avanti",
      back: "Indietro",
      skip: "Salta",
      submit: "Invia richiesta",
      thankYou: "Grazie!",
      thankYouText: "Ti risponderemo al più presto.",
    },
    floatingCta: {
      projectInquiry: "Richiesta progetto",
      whatsapp: "WhatsApp",
      call: "Chiama",
      email: "E-mail",
      form: "Modulo",
      assistant: "Assistente",
    },
    theme: {
      light: "Tema chiaro",
      dark: "Tema scuro",
    },
    lampCategories: {
      pendelleuchten: "Sospensioni",
      deckenleuchten: "Plafoniere",
      wandleuchten: "Applique",
      stehleuchten: "Lampade da terra",
      tischleuchten: "Lampade da tavolo",
      outdoor: "Illuminazione esterna",
      architektonisch: "Illuminazione architettonica",
    },
    furnitureCategories: {
      sofas: "Divani",
      sessel: "Poltrone",
      betten: "Letti",
      "tische-stuehle": "Tavoli e sedie",
      accessoires: "Accessori",
    },
  },

  /* ═══════════════════════════════ ESPAÑOL ═══════════════════════════════ */
  es: {
    nav: {
      home: "Inicio",
      about: "Agencia",
      products: "Catálogo",
      contact: "Contacto",
      selection: "Selección de iluminación",
      lighting: "Iluminación",
      howItWorks: "Cómo funciona",
      tagline: "Iluminación refinada y mobiliario seleccionado para espacios arquitectónicos y de interior.",
      browseLighting: "Descubrir iluminación",
      manufacturers: "Fabricantes",
      lamps: "Iluminación",
      furniture: "Mobiliario",
      allManufacturers: "Descubrir todos los fabricantes",
      order: "Pedir ahora",
    },
    hero: {
      kicker: "Frank Pistorius — Agencia comercial de iluminación",
      title: "Dar forma a los espacios con luz.",
      subtitle: "Luminarias arquitectónicas y mobiliario seleccionado.",
      cta: "Hablemos del proyecto",
      ctaSecondary: "Solicitar asesoramiento",
      catalogue: "Catálogo",
    },
    chooseLamps: {
      title: "Encuentra la luminaria perfecta para tu espacio",
      text: "Luminarias arquitectónicas y mobiliario seleccionado, curados para proyectos de interior que exigen calidad, precisión y diseño perdurable.",
      cta: "Explorar el catálogo",
    },
    categories: {
      pendants: "Lámparas colgantes y arañas",
      pendantsDesc: "Iluminación de impacto para comedores, salones, vestíbulos y proyectos de hostelería — seleccionada por calidad de diseño y relevancia duradera.",
      wallArchitectural: "Iluminación arquitectónica y de pared",
      wallArchitecturalDesc: "Soluciones limpias y funcionales para pasillos, dormitorios y paredes de acento — con soporte de planificación para espacios reales.",
      tableFloor: "Lámparas de mesa y de pie",
      tableFloorDesc: "Piezas flexibles orientadas al diseño que aportan atmósfera y confort — ideales para interiores privados y proyectos boutique.",
      byRequest: "Bajo petición",
      viewCollection: "Ver colección",
    },
    midCta: {
      text: "Asesoramiento personalizado para elegir la iluminación adecuada para tu espacio — desde renovación y obra nueva hasta proyectos de interior a medida.",
    },
    experience: {
      title: "Más de 35 años de experiencia en iluminación y conocimiento del mercado.",
      cta: "Conocer la agencia",
      stat1Title: "35+ años de experiencia",
      stat1Desc: "Décadas de conocimiento del sector, construido sobre relaciones duraderas con fabricantes y distribuidores.",
      stat2Title: "Fabricantes seleccionados",
      stat2Desc: "Un portfolio enfocado de marcas elegidas por su solidez en diseño, calidad y fiabilidad.",
      stat3Title: "Soporte de proyecto",
      stat3Desc: "Apoyo en planificación, selección y coordinación — para espacios arquitectónicos y de interior.",
      stat4Title: "Contacto directo",
      stat4Desc: "Un único interlocutor, respuestas rápidas y atención personal desde la primera consulta hasta el pedido final.",
    },
    footerCta: {
      title: "Mantente conectado.",
      text: "Recibe actualizaciones ocasionales y contáctanos en cualquier momento para soporte de proyectos o piezas de iluminación individuales.",
    },
    positioning: {
      headline: "Experiencia que facilita la elección.",
      text: "Más de tres décadas de conocimiento del mercado y un portfolio cuidadosamente curado — para que la solución correcta se encuentre más rápido. Con un único interlocutor.",
    },
    selection: {
      title: "Selección de iluminación",
      subtitle: "Sin búsquedas interminables. Un camino curado hacia la solución correcta.",
      step1Title: "Comprender el espacio",
      step1Desc: "Empezamos por el espacio, la arquitectura, el ambiente. No por un catálogo.",
      step2Title: "Curar marcas y tipologías",
      step2Desc: "De nuestro portfolio seleccionamos los fabricantes y tipos de luminarias que se ajustan a la tarea.",
      step3Title: "Coordinar especificaciones",
      step3Desc: "Detalles técnicos, disponibilidad, soluciones a medida — todo desde una única fuente.",
      step4Title: "Acompañar hasta la decisión",
      step4Desc: "Acompañamos a arquitectos, diseñadores y clientes hasta la selección final.",
    },
    manufacturers: {
      title: "Fabricantes seleccionados",
      subtitle: "Marcas de diseño internacionales, curadas personalmente.",
      kdln: { name: "KDLN", short: "Luz poética desde Milán. Formas no convencionales desde 1996." },
      quasar: { name: "Quasar Holland", short: "Arañas de vanguardia y objetos luminosos de los Países Bajos." },
      vistosi: { name: "Vistosi", short: "Vidrio de Murano soplado a boca. Tradición desde 1585." },
      nemo: { name: "Nemo Lighting", short: "Cultura de iluminación milanesa. De Le Corbusier hasta hoy." },
      aemotional: { name: "a·emotional light", short: "Objetos luminosos escultóricos. La artesanía encuentra la emoción." },
      vibieffe: { name: "Vibieffe", short: "Muebles tapizados italianos. Elegancia atemporal desde 1968." },
    },
    products: {
      title: "Catálogo",
      subtitle: "Luminarias y mobiliario de fabricantes seleccionados.",
      categories: "Luminarias por tipología",
      lamps: "Luminarias",
      furniture: "Mobiliario",
      pendant: "Lámparas colgantes",
      pendantDesc: "Presencia escultórica sobre mesa y espacio.",
      wall: "Apliques de pared",
      wallDesc: "Crear acentos. Luz sobre la arquitectura.",
      floor: "Lámparas de pie",
      floorDesc: "Gestos luminosos independientes para cada estancia.",
      table: "Lámparas de mesa",
      tableDesc: "Luz íntima. Cercana y personal.",
      architectural: "Iluminación arquitectónica",
      architecturalDesc: "Empotrada. Integrada. Invisible pero impactante.",
      outdoor: "Iluminación exterior",
      outdoorDesc: "Luz para fachadas, jardines y paisajes.",
      manufacturersTitle: "Nuestros fabricantes",
      manufacturersSubtitle: "Cada marca de nuestro portfolio fue seleccionada personalmente — por calidad, lenguaje de diseño y convicción.",
    },
    about: {
      title: "La agencia",
      subtitle: "Agencia comercial de iluminación",
      story: "Más de 30 años de experiencia en distribución y asesoramiento de iluminación. Una agencia independiente con sede en Bochum, que representa marcas de diseño internacionales seleccionadas.",
      story2: "Frank Pistorius actúa como asesor, curador e interfaz entre fabricante y proyecto. Ya sea arquitecto, interiorista, hotel, promotor o cliente privado — el foco está siempre en la solución correcta.",
      positioning: "Experiencia que facilita la elección. Más de tres décadas de conocimiento del mercado y un portfolio cuidadosamente curado, para que la solución correcta se encuentre más rápido — con un único interlocutor.",
      values: "Valores",
      value1Title: "Curado",
      value1Desc: "Sin surtido masivo. Cada fabricante fue elegido conscientemente.",
      value2Title: "Independiente",
      value2Desc: "Sin vínculos corporativos. Asesoramiento en interés del proyecto.",
      value3Title: "Personal",
      value3Desc: "Un único interlocutor. Directo, fiable, accesible.",
      founderName: "Frank Pistorius",
      founderRole: "Fundador y propietario",
      founderAlt: "Frank Pistorius – Fundador de la agencia comercial de iluminación",
      heroSubline: "Agencia comercial de iluminación",
      heroInfo1: "Más de 30 años como agencia comercial para iluminación y mobiliario.",
      heroInfo2: "Portfolio curado, asesoramiento claro, atención personal.",
      heroInfo3: "Para arquitectura, interiorismo y proyectos exigentes.",
    },
    contact: {
      title: "Iniciar un proyecto",
      subtitle: "Describe tu proyecto — encontraremos la solución adecuada.",
      name: "Nombre",
      email: "Correo electrónico",
      phone: "Teléfono",
      message: "Descripción del proyecto",
      projectType: "Tipo de proyecto",
      send: "Enviar consulta",
      info: "Contacto directo",
      address: "Dirección",
      hours: "Disponibilidad",
      hoursValue: "Lun–Vie: 10:00 – 18:00",
      cta1: "Solicitar asesoramiento de iluminación",
      cta2: "Seleccionar una luminaria",
      contactUs: "Contactar",
      nameRequired: "El nombre es obligatorio.",
      emailRequired: "El correo electrónico es obligatorio.",
      emailInvalid: "Introduce una dirección de correo válida.",
      messageRequired: "Describe tu proyecto.",
      privacyRequired: "Acepta la política de privacidad.",
      privacyLabel: "Acepto la",
      privacyLink: "política de privacidad",
      successTitle: "Consulta enviada",
      successText: "Gracias por tu consulta. Te responderemos a la brevedad.",
      newInquiry: "Nueva consulta",
    },
    footer: {
      rights: "Todos los derechos reservados.",
      tagline: "Agencia comercial de iluminación",
      forCustomers: "Para clientes",
      support: "Ayuda",
      followUs: "Síguenos",
      stayConnected: "Mantente conectado.",
      stayConnectedText: "Recibe actualizaciones ocasionales y contáctanos en cualquier momento.",
      impressum: "Aviso legal",
      datenschutz: "Privacidad",
      cookiePolicy: "Política de Cookies",
      terms: "Términos de Servicio",
    },
    assistant: {
      title: "Asistente de proyecto",
      whatPlanning: "¿Qué estás planeando?",
      singleLuminaire: "Luminaria individual",
      projectMultiple: "Proyecto / varias luminarias",
      fullInterior: "Interiorismo completo",
      justBrowsing: "Solo informarme",
      whereProject: "¿Dónde se encuentra el proyecto?",
      locationPlaceholder: "Código postal o ciudad",
      whenRealized: "¿Cuándo debe realizarse?",
      nowUrgent: "Ahora / urgente",
      months1to3: "En 1–3 meses",
      months3to6: "En 3–6 meses",
      notDecided: "Aún no decidido",
      yourName: "¿Cómo te llamas?",
      namePlaceholder: "Nombre y apellido",
      yourEmail: "¿Cómo podemos contactarte?",
      emailPlaceholder: "Dirección de correo electrónico",
      phonePlaceholder: "Número de teléfono (opcional)",
      next: "Siguiente",
      back: "Atrás",
      skip: "Saltar",
      submit: "Enviar consulta",
      thankYou: "¡Gracias!",
      thankYouText: "Te responderemos a la brevedad.",
    },
    floatingCta: {
      projectInquiry: "Consulta de proyecto",
      whatsapp: "WhatsApp",
      call: "Llamar",
      email: "Correo",
      form: "Formulario",
      assistant: "Asistente",
    },
    theme: {
      light: "Modo claro",
      dark: "Modo oscuro",
    },
    lampCategories: {
      pendelleuchten: "Lámparas colgantes",
      deckenleuchten: "Plafones",
      wandleuchten: "Apliques de pared",
      stehleuchten: "Lámparas de pie",
      tischleuchten: "Lámparas de mesa",
      outdoor: "Iluminación exterior",
      architektonisch: "Iluminación arquitectónica",
    },
    furnitureCategories: {
      sofas: "Sofás",
      sessel: "Sillones",
      betten: "Camas",
      "tische-stuehle": "Mesas y sillas",
      accessoires: "Accesorios",
    },
  },

  /* ═══════════════════════════════ NEDERLANDS ═══════════════════════════════ */
  nl: {
    nav: {
      home: "Home",
      about: "Agentschap",
      products: "Assortiment",
      contact: "Contact",
      selection: "Lichtselectie",
      lighting: "Verlichting",
      howItWorks: "Hoe het werkt",
      tagline: "Verfijnde verlichting en geselecteerd meubilair voor architectonische en interieurruimtes.",
      browseLighting: "Verlichting ontdekken",
      manufacturers: "Fabrikanten",
      lamps: "Verlichting",
      furniture: "Meubilair",
      allManufacturers: "Alle fabrikanten ontdekken",
      order: "Nu bestellen",
    },
    hero: {
      kicker: "Frank Pistorius — Handelsagentuur voor verlichting",
      title: "Ruimtes vormgeven met licht.",
      subtitle: "Architecturale armaturen en geselecteerd meubilair.",
      cta: "Project bespreken",
      ctaSecondary: "Lichtadvies aanvragen",
      catalogue: "Catalogus",
    },
    chooseLamps: {
      title: "Vind het perfecte licht voor uw ruimte",
      text: "Architecturale armaturen en geselecteerd meubilair, samengesteld voor interieurprojecten die kwaliteit, precisie en blijvend design vereisen.",
      cta: "Assortiment bekijken",
    },
    categories: {
      pendants: "Hanglampen en kroonluchters",
      pendantsDesc: "Opvallende verlichting voor eetruimtes, woonkamers, lobby's en horecaprojecten — geselecteerd op ontwerpkwaliteit en blijvende relevantie.",
      wallArchitectural: "Architecturale en wandverlichting",
      wallArchitecturalDesc: "Strakke, functionele oplossingen voor gangen, slaapkamers en accentwanden — met planningsondersteuning voor echte ruimtes.",
      tableFloor: "Tafel- en vloerlampen",
      tableFloorDesc: "Flexibele, designgerichte stukken die sfeer en comfort brengen — ideaal voor privé-interieurs en boutiqueprojecten.",
      byRequest: "Op aanvraag",
      viewCollection: "Collectie bekijken",
    },
    midCta: {
      text: "Advies op maat om de juiste verlichting voor uw ruimte te kiezen — van renovatie en nieuwbouw tot maatwerk interieurprojecten.",
    },
    experience: {
      title: "Meer dan 35 jaar verlichtingsexpertise en marktervaring.",
      cta: "Meer over het bedrijf",
      stat1Title: "35+ jaar ervaring",
      stat1Desc: "Decennia van sectorkennis, opgebouwd door langdurige relaties met fabrikanten en retailers.",
      stat2Title: "Geselecteerde fabrikanten",
      stat2Desc: "Een gericht portfolio van merken, geselecteerd op ontwerpkracht, kwaliteit en betrouwbaarheid.",
      stat3Title: "Projectondersteuning",
      stat3Desc: "Ondersteuning bij planning, selectie en coördinatie — voor architectonische en interieurruimtes.",
      stat4Title: "Direct contact",
      stat4Desc: "Eén duidelijk aanspreekpunt, snelle antwoorden en persoonlijke begeleiding van eerste aanvraag tot definitieve bestelling.",
    },
    footerCta: {
      title: "Blijf verbonden.",
      text: "Ontvang af en toe updates en neem op elk moment contact op voor projectondersteuning of individuele verlichtingsstukken.",
    },
    positioning: {
      headline: "Ervaring die het kiezen vergemakkelijkt.",
      text: "Meer dan drie decennia marktkennis en een zorgvuldig samengesteld portfolio — zodat de juiste oplossing sneller gevonden wordt. Met één duidelijk aanspreekpunt.",
    },
    selection: {
      title: "Lichtselectie",
      subtitle: "Geen eindeloos zoeken. Een gecureerd pad naar de juiste oplossing.",
      step1Title: "De ruimte begrijpen",
      step1Desc: "We beginnen met de ruimte, de architectuur, de sfeer. Niet met een catalogus.",
      step2Title: "Merken en typologieën cureren",
      step2Desc: "Uit ons portfolio selecteren we de fabrikanten en armatuurtypen die bij de opdracht passen.",
      step3Title: "Specificaties coördineren",
      step3Desc: "Technische details, beschikbaarheid, maatwerkoplossingen — alles uit één bron.",
      step4Title: "Begeleiden tot de beslissing",
      step4Desc: "We begeleiden architecten, planners en opdrachtgevers tot aan de definitieve selectie.",
    },
    manufacturers: {
      title: "Geselecteerde fabrikanten",
      subtitle: "Internationale designmerken, persoonlijk samengesteld.",
      kdln: { name: "KDLN", short: "Poëtisch licht uit Milaan. Onconventionele vormen sinds 1996." },
      quasar: { name: "Quasar Holland", short: "Avant-garde kroonluchters en lichtobjecten uit Nederland." },
      vistosi: { name: "Vistosi", short: "Mondgeblazen Muranoglas. Traditie sinds 1585." },
      nemo: { name: "Nemo Lighting", short: "Milanese verlichtingscultuur. Van Le Corbusier tot vandaag." },
      aemotional: { name: "a·emotional light", short: "Sculpturale lichtobjecten. Ambacht ontmoet emotie." },
      vibieffe: { name: "Vibieffe", short: "Italiaans gestoffeerd meubilair. Tijdloos elegant sinds 1968." },
    },
    products: {
      title: "Assortiment",
      subtitle: "Armaturen en meubilair van geselecteerde fabrikanten.",
      categories: "Armaturen per typologie",
      lamps: "Armaturen",
      furniture: "Meubilair",
      pendant: "Hanglampen",
      pendantDesc: "Sculpturale aanwezigheid boven tafel en ruimte.",
      wall: "Wandlampen",
      wallDesc: "Accenten zetten. Licht op de architectuur.",
      floor: "Vloerlampen",
      floorDesc: "Vrijstaande lichtgebaren voor elke ruimte.",
      table: "Tafellampen",
      tableDesc: "Intiem licht. Dichtbij en persoonlijk.",
      architectural: "Architecturale verlichting",
      architecturalDesc: "Ingebouwd. Geïntegreerd. Onzichtbaar maar doeltreffend.",
      outdoor: "Buitenverlichting",
      outdoorDesc: "Licht voor gevels, tuinen en landschappen.",
      manufacturersTitle: "Onze fabrikanten",
      manufacturersSubtitle: "Elk merk in ons portfolio is persoonlijk geselecteerd — op kwaliteit, designtaal en overtuiging.",
    },
    about: {
      title: "Het agentschap",
      subtitle: "Handelsagentuur voor verlichting",
      story: "Meer dan 30 jaar ervaring in verlichtingsdistributie en -advies. Een onafhankelijk agentschap gevestigd in Bochum, dat geselecteerde internationale designmerken vertegenwoordigt.",
      story2: "Frank Pistorius treedt op als adviseur, curator en schakel tussen fabrikant en project. Of het nu gaat om een architect, interieurontwerper, hotel, projectontwikkelaar of particuliere klant — de focus ligt altijd op de juiste oplossing.",
      positioning: "Ervaring die het kiezen vergemakkelijkt. Meer dan drie decennia marktkennis en een zorgvuldig samengesteld portfolio, zodat de juiste oplossing sneller gevonden wordt — met één duidelijk aanspreekpunt.",
      values: "Waarden",
      value1Title: "Gecureerd",
      value1Desc: "Geen massassortiment. Elke fabrikant is bewust gekozen.",
      value2Title: "Onafhankelijk",
      value2Desc: "Geen bedrijfsbanden. Advies in het belang van het project.",
      value3Title: "Persoonlijk",
      value3Desc: "Eén aanspreekpunt. Direct, betrouwbaar, bereikbaar.",
      founderName: "Frank Pistorius",
      founderRole: "Oprichter en eigenaar",
      founderAlt: "Frank Pistorius – Oprichter van het handelsagentuur voor verlichting",
      heroSubline: "Handelsagentuur voor verlichting",
      heroInfo1: "Al meer dan 30 jaar handelsagentuur voor verlichting en inrichting.",
      heroInfo2: "Gecureerd portfolio, helder advies, persoonlijke begeleiding.",
      heroInfo3: "Voor architectuur, interieur en veeleisende projecten.",
    },
    contact: {
      title: "Project starten",
      subtitle: "Beschrijf uw project — wij vinden de juiste oplossing.",
      name: "Naam",
      email: "E-mail",
      phone: "Telefoon",
      message: "Projectbeschrijving",
      projectType: "Projecttype",
      send: "Projectaanvraag versturen",
      info: "Direct contact",
      address: "Adres",
      hours: "Bereikbaarheid",
      hoursValue: "Ma–Vr: 10:00 – 18:00 uur",
      cta1: "Lichtadvies aanvragen",
      cta2: "Armatuur selecteren",
      contactUs: "Contact opnemen",
      nameRequired: "Naam is verplicht.",
      emailRequired: "E-mail is verplicht.",
      emailInvalid: "Voer een geldig e-mailadres in.",
      messageRequired: "Beschrijf uw project.",
      privacyRequired: "Accepteer het privacybeleid.",
      privacyLabel: "Ik accepteer het",
      privacyLink: "privacybeleid",
      successTitle: "Aanvraag verstuurd",
      successText: "Bedankt voor uw aanvraag. Wij nemen spoedig contact met u op.",
      newInquiry: "Nieuwe aanvraag",
    },
    footer: {
      rights: "Alle rechten voorbehouden.",
      tagline: "Handelsagentuur voor verlichting",
      forCustomers: "Voor klanten",
      support: "Ondersteuning",
      followUs: "Volg ons",
      stayConnected: "Blijf verbonden.",
      stayConnectedText: "Ontvang af en toe updates en neem op elk moment contact op.",
      impressum: "Colofon",
      datenschutz: "Privacybeleid",
      cookiePolicy: "Cookiebeleid",
      terms: "Gebruiksvoorwaarden",
    },
    assistant: {
      title: "Projectassistent",
      whatPlanning: "Wat bent u aan het plannen?",
      singleLuminaire: "Enkel armatuur",
      projectMultiple: "Project / meerdere armaturen",
      fullInterior: "Volledige inrichting",
      justBrowsing: "Alleen informeren",
      whereProject: "Waar bevindt het project zich?",
      locationPlaceholder: "Postcode of stad",
      whenRealized: "Wanneer moet het gerealiseerd worden?",
      nowUrgent: "Nu / dringend",
      months1to3: "Binnen 1–3 maanden",
      months3to6: "Binnen 3–6 maanden",
      notDecided: "Nog niet beslist",
      yourName: "Hoe heet u?",
      namePlaceholder: "Voor- en achternaam",
      yourEmail: "Hoe kunnen we u bereiken?",
      emailPlaceholder: "E-mailadres",
      phonePlaceholder: "Telefoonnummer (optioneel)",
      next: "Volgende",
      back: "Terug",
      skip: "Overslaan",
      submit: "Aanvraag versturen",
      thankYou: "Bedankt!",
      thankYouText: "Wij nemen spoedig contact met u op.",
    },
    floatingCta: {
      projectInquiry: "Projectaanvraag",
      whatsapp: "WhatsApp",
      call: "Bellen",
      email: "E-mail",
      form: "Formulier",
      assistant: "Assistent",
    },
    theme: {
      light: "Licht thema",
      dark: "Donker thema",
    },
    lampCategories: {
      pendelleuchten: "Hanglampen",
      deckenleuchten: "Plafondlampen",
      wandleuchten: "Wandlampen",
      stehleuchten: "Vloerlampen",
      tischleuchten: "Tafellampen",
      outdoor: "Buitenverlichting",
      architektonisch: "Architecturale verlichting",
    },
    furnitureCategories: {
      sofas: "Bank",
      sessel: "Fauteuils",
      betten: "Bedden",
      "tische-stuehle": "Tafels & stoelen",
      accessoires: "Accessoires",
    },
  },
} as const;

export type Translations = (typeof translations)[Language];
